import {Component, OnDestroy, OnInit} from '@angular/core';
import {ApiService} from '../../services/api.service';
import {AuthenticationService} from '../../services/authentication.service';
import {NgbModal, NgbModalRef, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {CALENDAR_LOCALE} from '../../services/constant';
import {HttpParams} from '@angular/common/http';
import * as _ from 'lodash';
import * as moment from 'moment';
import {Subscription} from "rxjs";

@Component({
  selector: 'app-import-data',
  templateUrl: './import-data.component.html',
  styleUrls: ['./import-data.component.scss']
})
export class ImportDataComponent implements OnInit, OnDestroy {
  itemsPerPage = 40;
  startDate: Date = null;
  endDate: Date = null;
  minDate: Date;
  maxDate: Date;
  totalItems = 0;
  selectedValues = [];
  currentPage = 1;
  statusData: any;
  selectedStatus: any;
  importMethod: any;
  selectedMethod: any;
  documentNumber: any;
  calendarLocale = CALENDAR_LOCALE.TH;
  loading = false;
  sortBy: string;
  sortMode: string;
  tableData: any = [];
  modalData: any;
  disable = false;
  modal: NgbModalRef;
  subs: Subscription;

  constructor(
    private apiService: ApiService,
    private authService: AuthenticationService,
    private modelService: NgbModule,
    private translate: TranslateService,
    private modalService: NgbModal
  ) {
  }

  ngOnInit() {
    this.subs = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.loadTexts();
    });
    this.loadTexts();
    this.loadData();
  }

  loadTexts() {
    if (this.translate.currentLang === 'en') {
      this.calendarLocale = CALENDAR_LOCALE.EN;
    } else {
      this.calendarLocale = CALENDAR_LOCALE.TH;
    }
    this.statusData = [
      {label: this.translate.instant('COMMON.ALL'), value: null},
      {label: this.translate.instant('TEXT.SUCCESS'), value: 'success'},
      {label: this.translate.instant('TEXT.FAILED'), value: 'failed'}
    ];
    this.importMethod = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];
    this.apiService.getAllImportMethods().subscribe(
      (result) => {
        _.forEach(result, (obj) => {
          this.importMethod.push({
            label: obj,
            value: obj
          });
        });
        this.importMethod = _.uniqBy(this.importMethod, 'label');
      },
      error => error(status)
    );
    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 60);
    this.endDate = new Date();
  }

  resolveError($event, popup: any, data: any) {
    this.modalData = data;
    this.disable = false;
    this.modal = this.modalService.open(popup, {backdrop: 'static', keyboard: false, centered: true});
  }

  revertBack() {
    this.modal.close();
  }

  get yearRange() {
    const thisYear = (new Date()).getFullYear();
    return (thisYear - 40) + ':' + thisYear;
  }

  get dateRange() {
    if (!this.startDate && !this.endDate) {
      return null;
    }

    const start = this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
    const end = this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : '';
    return start + ' - ' + end;
  }

  pageChanged() {
    // const params = new HttpParams().set('page', _.toString(this.currentPage));
    this.loadData();
  }

  setMinDate() {
    this.minDate = this.startDate;
  }

  setMaxDate() {
    this.maxDate = this.endDate;
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  sort(event) {
    this.sortBy = event.field;
    if (event.order === 1) {
      this.sortMode = '';
    } else {
      this.sortMode = '-';
    }
  }

  clearSearch() {
    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 60);
    this.selectedStatus = null;
    this.selectedMethod = null;
    this.documentNumber = null;
    this.startDate = null;
    this.endDate = new Date();
    this.startDate = new Date();
    this.sortBy = null;
    this.sortMode = null;
    this.totalItems = null;
    this.disable = false;
    this.modal = null;
    this.loadTexts();
    this.loadData();
  }

  searchButtonClicked() {
    this.currentPage = 1;
    this.sortBy = null;
    this.sortMode = null;
    this.loadData();
  }

  downloadCsvOrPdfFile(fileName, url) {
    const mediaUrl = url.split('media/')[1];
    const ext = mediaUrl.slice(-3);
    this.apiService.downloadFileFromMediaPath(mediaUrl).subscribe(
      (obj) => {
        this.apiService.createDownloadFile(obj, fileName);
        if (ext === 'csv') {
          this.sniff('DOWNLOAD_ORI_CSV', fileName);
        } else {
          this.sniff('DOWNLOAD_ORI_PDF', fileName);
        }
      },
      error => {
      });
  }

  downloadJsonFile(json) {
    const blob = new Blob([JSON.stringify(json, null, 2)], {type: 'application/json'});
    const issueDtOnlyDate = json.data.header.issue_dt.slice(0, 10).replace(/-/g, '_');
    const fileName = json.data.header.invoice_number + '_' + json.file_type + '_' + issueDtOnlyDate + '.json';
    this.apiService.createDownloadFile(blob, fileName);
    this.sniff('DOWNLOAD_ORI_JSON', fileName);
  }

  loadData(param?) {
    this.tableData = [];
    const startDates = moment(this.startDate).format('YYYY-MM-DD');
    const endDates = moment(this.endDate).format('YYYY-MM-DD');
    let params = new HttpParams();
    if (this.startDate) {
      params = params.append('header_issue_date_start', startDates);
      params = params.append('header_issue_date_end', endDates);
    }
    if (this.sortBy) {
      params = params.append('ordering', this.sortMode + this.sortBy);
    }
    params = params.append('page', this.currentPage.toString());
    params = params.append('items_per_page', this.itemsPerPage.toString());
    if (this.selectedStatus) {
      params = params.append('status', this.selectedStatus);
    }
    if (this.selectedMethod) {
      params = params.append('method', this.selectedMethod);
    }
    if (this.documentNumber) {
      params = params.append('invoice_number', this.documentNumber);
    }
    this.loading = true;
    this.apiService.getErrors(params).subscribe(
      (data) => {
        _.forEach(data.results, obj => {
          this.tableData.push({
            'created_at': obj.created_at,
            'method': obj.method,
            'status_display': obj.status === 'doing' ? 'DASHBOARD.PROCESSING' : 'DASHBOARD.' + obj.status.toUpperCase(),
            'json': obj.json,
            'csv_name': obj.tax_import === null ? '-' : obj.tax_import.csv_name,
            'csv_file': obj.tax_import === null ? '-' : obj.tax_import.csv_file,
            'pdf_name': obj.tax_import === null || obj.tax_import.pdf_name === null ? '-' : obj.tax_import.pdf_name,
            'pdf_file': obj.tax_import === null || obj.tax_import_pdf_file === null ? '-' : obj.tax_import.pdf_file,
            'invoice_number': obj.invoice_number,
            'detail': obj.detail === null || obj.detail.message === null ? '-' : obj.detail.message,
            'row': obj.detail === null || obj.detail.row === null ? '-' : obj.detail.row
          });
        });
        this.totalItems = data.count;
        this.loading = false;
      }
    );
  }

  sniff(action, target) {
    const data = {
      action: action,
      address: 'IMPORT_DATA',
      target: target
    };
    this.apiService.sniff(data).subscribe(
      (res: any) => {
      },
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/import-data/import-data.component.ts